import { Link } from "react-router-dom";
import useTask from "../../modules/tasks/hooks/use-task";
import useUser from "../../modules/user/hooks/use-user";
import { getTaskRoute } from "../../routes/routes";

type Props = {
    id: string
}

const TaskLink: React.FC<Props> = ({ id }) => {

    const { user } = useUser();
    const { task } = useTask(id);
    const isAvaiable = task?.requires ? user?.completedTasks.includes(task.requires) : true;

    const label = task?.mapNumber || 'x';

    return <>
        {isAvaiable && <Link className={`task-circle ${id}`} to={getTaskRoute(id)}>
            <div className="task-circle-inner">
                <div className="task-circle-inner-2">
                    {label}
                </div>
            </div>
        </Link>}
    </>
}

export default TaskLink;
